export enum TLAreaType {
    LANGUAGE = 'LANGUAGE',
    MENTAL_SCHEME = 'MENTAL_SCHEME',
    PRIOR_KNOWLEDGE = 'PRIOR_KNOWLEDGE',
    VERIFY_KNOWLEDGE = 'VERIFY_KNOWLEDGE'
}

export enum TLFunctionType {
    DICTIONARY = 'DICTIONARY',
    SIMPLIFY = 'SIMPLIFY',
    OUTLINE = 'OUTLINE',
    SUMMARY = 'SUMMARY',
    TIMELINE = 'TIMELINE',
    CAUSE_EFFECT = 'CAUSE_EFFECT',
    WHO_WHAT_WHERE_WHEN = 'WHO_WHAT_WHERE_WHEN',
    BEFORE_READ = 'BEFORE_READ',
    BASIS = 'BASIS',
    EXERCISES = 'EXERCISES',
    QUESTIONS = 'QUESTIONS',
    TUTOR_QUIZ = 'TUTOR_QUIZ'
}

export interface TLArea {
    icon: string;
    title: string;
    description: string;
    theme: string;
    functions: TLAreaFunction[];
    areaType: TLAreaType;
    enabled: boolean;
}

export interface TLAreaFunction {
    icon: string;
    title: string;
    description: string;
    cost: number;
    functionType: TLFunctionType;
    enabled: boolean;
}